<template lang="pug">
div
  v-data-table.elevation-1(
    :items="items",
    :page.sync="page",
    :loading="loading",
    :headers="headers",
    :item-key="itemKey",
    hide-default-footer,
    :items-per-page="itemsPerPage",
    :search="searchServer ? undefined : search",
    loading-text="Cargando... Por favor espere"
  )
    template(v-slot:item.date_exp="{ item }") {{ formattedDate(item.date_exp) }}
    template(v-slot:item.status_pet.created="{ item }") {{ formattedDate(item.status_pet.created) }}
    template(v-slot:item.date="{ item }") {{ onlyDate ? formattedDate(item.date) : formattedDateTime(item.date) }}
    template(v-slot:item.sale_date="{ item }") {{ onlyDate ? formattedDate(item.sale_date) : formattedDateTime(item.sale_date) }}
    template(v-slot:item.purchase_date="{ item }") {{ onlyDate ? formattedDate(item.purchase_date) : formattedDateTime(item.purchase_date) }}

    template(v-slot:item.gender="{ item }") {{ getNameChoiceGender(item.gender) }}

    template(v-slot:item.specie="{ item }") {{ item.specie != null ? item.specie : "N/A" }}

    template(v-slot:item.color="{ item }") {{ item.color != null ? item.color : "N/A" }}

    template(v-slot:item.inventory_type="{ item }") {{ getNameChoiceInventoryType(item.inventory_type) }}

    template(v-slot:item.assign="{ item }")
      v-chip(:color="(item.pet != null && item.owner != null) ? 'green' : 'red'")
        label.white--text(v-if="item.pet != null && item.owner != null") Asignado
        label.white--text(v-else) No Asignado

    template(v-slot:item.assign_vet="{ item }")
      v-chip(:color="(item.vet != null) ? 'green' : 'red'")
        label.white--text(v-if="item.vet != null") Asignado
        label.white--text(v-else) No Asignado

    template(v-slot:item.actions="{ item }")
      v-tooltip(v-if="additionalsAccions && enableView", bottom)
        template(v-slot:activator="{ on, attrs }")
          v-icon.mr-2(
            small,
            v-bind="attrs",
            v-on="on",
            @click="$emit('view', item)"
          ) far fa-eye
        span Ver
      v-tooltip(v-if="enableActions && enableEdit" ,bottom)
        template(v-slot:activator="{ on, attrs }")
          v-icon.mr-2(
            small,
            v-bind="attrs",
            v-on="on",
            @click="!loadingBtnEdit ? $emit('edit', item) : null"
          ) fas fa-edit
        span Editar
      v-tooltip(v-if="enableActions && enableDelete", bottom)
        template(v-slot:activator="{ on, attrs }")
          v-icon.mr-2(
            small,
            v-bind="attrs",
            v-on="on",
            @click="$emit('delete', item)"
          ) far fa-trash-alt
        span Eliminar
      v-tooltip(v-if="additionalsAccions", bottom)
        template(v-slot:activator="{ on, attrs }")
          v-icon.mr-2(
            small,
            v-bind="attrs",
            v-on="on",
            @click="$emit('downloadCarnet', item)"
          ) fas fa-id-card
        span Descargar Carnet
      //- v-tooltip(v-if='additionalsAccions', bottom)
      //-   template(v-slot:activator="{ on, attrs }")
      //-     v-icon.mr-2(small, v-bind="attrs", v-on="on", @click='downloadVaccineCardItem(item)') fas fa-notes-medical
      //-   span Descargar Historial Medico
      v-tooltip(v-if="additionalsAccions", bottom)
        template(v-slot:activator="{ on, attrs }")
          v-icon.mr-2(
            small,
            v-bind="attrs",
            v-on="on",
            @click="$emit('downloadVaccineCard', item)"
          ) fas fa-syringe
        span Descargar Carnet de Vacunación
      v-tooltip(v-if="enableGenQR", bottom)
        template(v-slot:activator="{ on, attrs }")
          v-icon.mr-2(
            small,
            v-bind="attrs",
            v-on="on",
            @click="$emit('generateQR', item)"
          ) fas fa-qrcode
        span Generar Código QR

      v-tooltip(v-if="item.role != null && item.role.slug=='vet'", bottom)
        template(v-slot:activator="{ on, attrs }")
          v-icon.mr-2(
            small,
            v-bind="attrs",
            v-on="on",
            @click="$emit('listInventories', item)"
          ) fas fa-boxes
        span Inventarios

    template(v-slot:top)
      v-toolbar(flat, color="white")
        v-toolbar-title
        v-spacer
        v-text-field.mx-2(
          single-line,
          hide-details,
          label="Buscar",
          v-model="search",
          append-icon="fas fa-search",
          @click:append="$emit('search', search)"
        )
  .text-center.pt-2
    v-pagination(
      circle,
      v-model="page",
      :length="pageCount",
      :total-visible="10",
      @input="getPage($event)"
    )
</template>

<script>
import moment from "moment";
import { mapState, mapGetters } from "vuex";

export default {
  name: "Table",
  props: {
    headers: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    pageCount: {
      type: Number,
      required: true,
    },
    itemsPerPage: {
      type: Number,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
    loadingBtnEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    additionalsAccions: {
      type: Boolean,
      required: false,
      default: false,
    },
    enableGenQR: {
      type: Boolean,
      required: false,
      default: false,
    },
    onlyDate: {
      type: Boolean,
      required: false,
      default: false,
    },
    searchServer: {
      type: Boolean,
      required: false,
      default: false,
    },
    itemKey: {
      type: String,
      required: false,
      default: "id",
    },
    enableActions: {
      type: Boolean,
      default: true,
      required: false,
    },
    enableDetailInventory: {
      type: Boolean,
      default: false,
      required: false,
    },
    enableEdit: {
      type: Boolean,
      default: true,
      required: false,
    },
    enableDelete: {
      type: Boolean,
      default: true,
      required: false,
    },
    enableView: {
      type: Boolean,
      default: true,
      required: false,
    }
  },
  computed: {
    ...mapGetters({
      choices: "selectChoices",
    }),
    ...mapState({
      user: (state) => state.auth.user,
    }),
  },
  data() {
    return {
      page: 1,
      search: "",
    };
  },
  methods: {
    formattedDate(date) {
      moment.locale("es-us");
      return moment(date).format("LL");
    },
    formattedDateTime(date) {
      moment.locale("es-us");
      return moment(date).format("LLLL");
    },
    getNameChoiceGender(id) {
      let gender = this.choices.gender.filter((gender) => gender.id == id)[0];
      return gender.name;
    },
    getNameChoiceInventoryType(id) {
      let inventory_type = this.choices.inventory_type.filter(
        (inventory_type) => inventory_type.id == id
      )[0];
      return inventory_type.name;
    },
    getPage(page) {
      this.$emit("getPage", page);
    },
  },
};
</script>
